<template>
  <div id="Footer" :style="{ color: primaryTextColor, '--footer-text': primaryTextColor, '--footer-bg': primaryColor, backgroundColor: primaryColor, background: primaryColor }">
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <!-- <h2>{{ $vuetify.lang.t('$vuetify.common.hours') }}</h2> -->

        <store-hours :store="getStore" />
      </v-flex>

      <v-flex xs12 sm6 md4 :class="{ 'addSpace': $vuetify.breakpoint.smAndDown }">
        <h2>{{ $vuetify.lang.t('$vuetify.common.location') }}</h2>

        <div class="contentRow">
          <a v-if="!!getStore.address || !!getStore.city" @click="openGoogleMap(getStore)">
            {{ getStore.address }}
            <br v-if="getStore.city">{{ getStore.city }}<span v-if="getStore.country">, {{
              getStore.country }}</span>
          </a>
        </div>


        <h2 v-if="!!getStore.phoneNumber" style="margin-top: 40px;">
          {{ $vuetify.lang.t('$vuetify.common.contact') }}
        </h2>

        <div v-if="!!getStore.phoneNumber || !!getStore.email" class="contentRow">
          <v-icon style="margin-right: 5px;" :color="primaryTextColor">phone</v-icon>
          <a :href="`tel:${getStore.phoneNumber}`">
            {{ getStore.phoneNumber || phone }} <br />
          </a>
        </div>

        <div v-if="!!orderEmail" class="contentRow">
          <v-icon style="margin-right: 5px;" :color="primaryTextColor">email</v-icon>
          <a :href="`mailto:${orderEmail}`">
            {{ orderEmail }} <br />
          </a>
        </div>
      </v-flex>

      <v-flex xs12 md3 :class="{ 'addSpace': $vuetify.breakpoint.smAndDown }">
        <h2>Socials</h2>

        <socials :store="getStore" />
      </v-flex>
    </v-layout>

    <v-divider style="margin: 15px 0px" />

    <!-- Matches OWA's own copyright row (StoreFooter.vue): plain block
         siblings, not a flex row forcing the copyright text and a 140px
         logo onto the same line -- that's what made "© 2026 Frank's test
         store" wrap to two lines at mobile widths where OWA's stays on one
         (OWA stacks them; the flex row here left the text column too
         narrow). Desktop keeps them side by side via the media query below,
         same breakpoint OWA's own #goSnappy positioning uses. -->
    <div class="copyright-row">
      <h2 style="position: relative; top: 5px">
        &copy; {{ currentYear }} {{ getStore.name }}
      </h2>
      <img id="goSnappy" src="/giftcard/img/Snappy-White-Full-Logo_402x-2.png" style="object-fit: contain;" width="140" height="60"
        :style="primaryTextColor === '#000000' ? { filter: 'brightness(0)' } : {}"
        contain />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StoreHours from './StoreHours';
import Socials from './Socials';
import get from 'lodash/get';
import { primaryTextColor } from '@/plugins/util';
export default {
  name: 'AppFooter',
  data() {
    return {}
  },
  computed: {
    primaryColor() {
      return this.$store.getters.getManifest?.meta?.primary || '#202124'
    },
    primaryTextColor() { return primaryTextColor(this.primaryColor) },
    ...mapGetters(['getStore']),
    orderEmail() {
      return get(this.getStore, 'settings.orderSettings.orderEmail')
    },
    currentYear() {
      return (new Date()).getFullYear()
    },
  },
  mounted() {
    
  },
  methods: {
    openGoogleMap(item) {
      const urlSuffix = item["address"] + ", " + item["city"] + ", " + item["postalCode"]

      window.open("https://www.google.com/maps/search/?api=1&query=" + urlSuffix, "_blank")
    }
  },
  components: {
    StoreHours,
    Socials
  }
}
</script>
<style>
#Footer,
#Footer *,
#Footer #StoreHours * {
  color: var(--footer-text) !important;
}
#Footer #tweetButton,
#Footer #tweetButton span,
#Footer .whatsapp-old,
#Footer .whatsapp-old span {
  color: white !important;
}
#Footer a,
#Footer h2 {
  display: inline-block;
}
</style>
<style scoped>
#Footer {
  position: relative;

  width: 100vw;
  background: var(--footer-bg, #000000) !important;
  background-color: var(--footer-bg, #000000) !important;
  padding: 20px 20px 0 20px;

  text-align: left;
  /* var(--text-size-1) is OWA/reservation's own CSS variable system, never
     defined in this app -- resolved to nothing (falling back to the browser
     default, close to OWA's 1rem by coincidence) rather than a real value. */
  font-size: 1rem;
}


.contentRow {
  display: block;
  margin-bottom: 10px;
}

/* Was applied in the template (:class="{ addSpace: ... }") but never
   defined here -- OWA's own #Footer has this exact rule (StoreFooter.vue)
   giving real breathing room between the stacked mobile sections
   (Hours/Location/Contact/Socials); without it those sections crowded
   together on mobile compared to OWA's footer. */
.addSpace {
  padding-top: 40px;
}

.copyright-row {
  display: block;
}
#goSnappy {
  width: 140px;
  margin-top: 20px;
}
/* Matches OWA's own #goSnappy breakpoint (StoreFooter.vue) -- side by side
   on desktop, stacked on mobile. */
@media all and (min-width: 960px) {
  .copyright-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #goSnappy {
    margin-top: 0;
  }
}
</style>